import React from "react";
import { Modal, Row, Col, Form } from "react-bootstrap";
import { UserFilterModalProps } from "../../types";

function UserFilterModal(props: UserFilterModalProps): JSX.Element {

    const { closeModal, show, filters, onFiltersChanged } = props;

    const onFieldChanged = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const maxPriceElement = document.getElementById("maxPrice") as HTMLInputElement;
        const minPriceElement = document.getElementById("minPrice") as HTMLInputElement;
        const hideSignedElement = document.getElementById("hideSigned") as HTMLInputElement;
        const hideRequestedElement = document.getElementById("hideRequested") as HTMLInputElement;
        const hideUnavailableElement = document.getElementById("hideUnavailable") as HTMLInputElement;
        const useMaxPriceElement = document.getElementById("useMaxPrice") as HTMLInputElement;
        const useMinPriceElement = document.getElementById("useMinPrice") as HTMLInputElement;
        const separateSearchTermsElement = document.getElementById("separateSearchTerms") as HTMLInputElement;

        const updatedFilters = {
            ...filters,
            maxPrice: parseFloat(maxPriceElement?.value || '0'),
            minPrice: parseFloat(minPriceElement?.value || '0'),
            hideSigned: hideSignedElement?.checked || false,
            hideRequested: hideRequestedElement?.checked || false,
            hideUnavailable: hideUnavailableElement?.checked || false,
            useMaxPrice: useMaxPriceElement?.checked || false,
            useMinPrice: useMinPriceElement?.checked || false,
            separateSearchTerms: separateSearchTermsElement?.checked || false
        };

        onFiltersChanged(updatedFilters);
    }

    return (
        <>
        <Modal show={show} onHide={closeModal} size="lg">
            <Modal.Header closeButton>
            <Modal.Title>Filters</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Row>
                <Col>
                    <Form.Check id="hideSigned" label="Hide Signed" checked={filters.hideSigned} onChange={onFieldChanged} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Check id="hideRequested" label="Hide Requested" checked={filters.hideRequested}  onChange={onFieldChanged} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Check id="hideUnavailable" label="Show Available Only" checked={filters.hideUnavailable}  onChange={onFieldChanged} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Check id="separateSearchTerms" label="Separate search terms by space" checked={filters.separateSearchTerms}  onChange={onFieldChanged} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Check id="useMaxPrice" label="Use Max Price" checked={filters.useMaxPrice} onChange={onFieldChanged} />
                </Col>
                <Col>
                    <Form.Control type="number" id="maxPrice" placeholder="Max Price" value={filters.maxPrice} onChange={onFieldChanged} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Check id="useMinPrice" label="Use Min Price" checked={filters.useMinPrice} onChange={onFieldChanged} />
                </Col>
                <Col>
                    <Form.Control type="number" id="minPrice" placeholder="Min Price" value={filters.minPrice} onChange={onFieldChanged} />
                </Col>
            </Row>
            </Modal.Body>
            <Modal.Footer>
                
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default UserFilterModal;
